<ng-container *ngIf="slicedComparisonData.length > 0" class="tab-content event-cont">
  <div class="match-row-header desktop"></div>

  <div class="compare-row-header mobile">
    <div class="match-row-container compare mobileheader">
      <div class="compare-match-row-match-info" style="border-right: 0px !important">
        <div class="match-info-date-time"></div>
      </div>

      <div class="compare-match-row-odds">
        <div class="header-odds-box">
          <ng-container>
            <div class="compare-box tipp">
              <span class="compare-box-text orange">Tipp</span>
            </div>
          </ng-container>

          <ng-container>
            <div class="compare-box">
              <span class="compare-box-text">
                <div class="logo-container">
                  <image-loader-utils extraClasses="logo" url="logo" [shared]="false" imageFormat="png"></image-loader-utils>
                </div>
              </span>
            </div>
          </ng-container>

          <ng-container>
            <div class="compare-box">
              <span class="compare-box-text">Tipico</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngFor="let dnm of slicedComparisonData; let i = index">
    <div class="match-row-container compare text">
      <div class="match-row-match-info compare">
        <div class="match-info-date-time">
          <div>
            {{ getWhich(dnm.EventDate) === 1 ? ('today' | t) : getWhich(dnm.EventDate) === 2 ? (dnm.EventDate | dateFormat : 'E') : (dnm.EventDate | dateFormat : 'dd-MM') }}
          </div>
          <!-- <div>
              {{ dnm.MatchTime }}
            </div> -->
        </div>

        <div class="match-info-teams" (click)="goEventDetail2(dnm.MatchId, dnm.MatchId, dnm)">
          <div class="flex">
            <div></div>

            {{ dnm.HomeTeam }}
          </div>
          <div class="flex">
            <div></div>
            {{ dnm.AwayTeam }}
          </div>
        </div>

        <div class="match-info-date-time mobile">
          <ng-container>
            <div>
              {{ getWhich(dnm.EventDate) === 1 ? ('today' | t) : getWhich(dnm.EventDate) === 2 ? (dnm.EventDate | dateFormat : 'E') : (dnm.EventDate | dateFormat : 'dd-MM') }}
            </div>
            <div>
              {{ dnm.EventDate | dateFormat : 'H:mm' }}
            </div>
          </ng-container>
        </div>
      </div>
      <div class="match-row-odds">
        <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
          <div *ngSwitchCase="'wettarena'" class="odds-box" style="display: flex !important">
            <ng-container>
              <div class="odd tipp">
                <span class="odd-text orange"> {{ dnm.OutCome }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd green">
                <span class="odd-value">{{ dnm.CurrentOddValue }}</span>
                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd">
                <span class="odd-value">{{ dnm.ExternalOddValue }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>
          </div>
          <div *ngSwitchCase="'b500'" class="odds-box" style="display: flex !important">
            <ng-container>
              <div class="odd tipp">
                <span class="odd-text orange"> {{ dnm.OutCome }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd green">
                <span class="odd-value">{{ dnm.CurrentOddValue }}</span>
                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd">
                <span class="odd-value">{{ dnm.ExternalOddValue }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>
          </div>
          <div *ngSwitchCase="'b3000'" class="odds-box" style="display: flex !important; height: 51px">
            <ng-container>
              <div class="odd tipp">
                <span class="odd-text orange"> {{ dnm.OutCome }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd green" [ngClass]="{ 'bottom-effect': i === slicedComparisonData.length - 1 }">
                <span class="odd-value">{{ dnm.CurrentOddValue.toFixed(2) }}</span>
              </div>
            </ng-container>

            <ng-container>
              <div class="odd">
                <span class="odd-value">{{ dnm.ExternalOddValue.toFixed(2) }}</span>

                <div class="{{ dnm['OddValue' + 'css'] }}"></div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="match-row-details">
        <image-loader-utils url="up-arrow" extraClasses="arrow-icon down"></image-loader-utils>
      </div>
    </div>
  </div>

  <div class="compare-sub-container">
    <div class="stake-container">
      <div class="stake-box">
        <div class="stake-item">{{ 'Total_Stake2' | t }}</div>
        <div class="stake-value">{{ balance }}€</div>
      </div>
      <div class="possible-box">{{ 'Possibly_Winning' | t }}</div>
    </div>
    <div class="compare-row-container">
      <div class="compare-container">
        <div class="compare-item-green">{{ possibleChanceCurrent * balance | number : '1.0-0' }}</div>
        <div class="compare-item">{{ possibleChanceExternal * balance | number : '1.0-0' }}</div>
      </div>
    </div>
  </div>
  <div class="compare-button-container">
    <div class="button-row">
      <div class="btn transparen">
        <div class="btn-text mobile-text" (click)="othersBet(true)">
          <image-loader-utils url="rotate" extraClasses="rotate-svg"></image-loader-utils>
          {{ 'Other_Bets' | t }}
        </div>
      </div>
    </div>
    <div class="button-row">
      <div class="btn mobile transparen green">
        <div class="btn-text mobile-text" (click)="clickNewOdd()">
          {{ 'Submit_bet' | t }}
        </div>
      </div>
    </div>
  </div>
  <div class="compare-info-container">
    {{ 'Compare_Text-Info' | t }}
  </div>
</ng-container>
<ng-container *ngIf="slicedComparisonData.length === 0">
  <div class="no-data-container">
    {{ 'Odd_Comparison_No_Data' | t }}
  </div>
</ng-container>
